import React, { useRef, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { BsCurrencyBitcoin, BsDice1 } from "react-icons/bs";
import { FaUserFriends, FaCalendarAlt, FaBriefcase, FaRobot, FaBook, FaMoneyCheckAlt, FaFileInvoiceDollar, FaCogs, FaClipboardCheck, FaPhoneAlt } from "react-icons/fa";
import { MdOutlineTour } from "react-icons/md";
import { useAuth } from "../../AuthProvider";
import "./navbar.scss";
import { Tag } from "antd";
import usePermissions from "../../access-control/auth/usePermissions";
// Define navigation structure here
const navSections = [
  {
    key: "Roster",
    label: "Roster",
    icon: <FaCalendarAlt size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER", "ROLE_EMPLOYEE", "ROLE_FWORKER"],
    links: [
      { to: "/schedule", label: "Roster", refKey: "link9" },
    ],
  },
  {
    key: "trade-jobs",
    label: "Trade Job",
    icon: <FaBriefcase size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER", "ROLE_EMPLOYEE"],
    defaultRoute: "/trade-job-dashboard",
    links: [
      { to: "/trade-job-dashboard", label: "Dashboard", refKey: "link12" },
      { to: "/trade-job-calendar", label: "Calendar", refKey: "link12c" },
      { to: "/trade-job-create", label: "Create a Job", refKey: "link12create" },
    ],
  },
  {
    key: "customer",
    label: "Customer",
    icon: <FaUserFriends size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER","ROLE_EMPLOYEE"],
    links: [
      { to: "/customer", label: "Manage Customer", refKey: "linkCust1" },
      { to: "/customer/search", label: "Search Customer", refKey: "linkCust2" },
      { to: "/customer/add", label: "Add New Customer", refKey: "linkCust3" },
    ],
  },
  {
    key: "inventory",
    label: "Inventory",
    icon: <FaBriefcase size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER"],
    links: [
      { to: "/inventory", label: "Manage Inventory", refKey: "linkInv1" },
      { to: "/inventory/search", label: "Search Inventory", refKey: "linkInv2" },
      { to: "/inventory/add", label: "Add New Item", refKey: "linkInv3" },
      { to: "/inventory/aicheck", label: "AI Inventory Check", refKey: "linkInvAI" },
    ],
  },
  {
    key: "ai-wiz",
    label: "AI Assist",
    icon: <FaRobot size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER","ROLE_EMPLOYEE"],
    links: [
      { to: "/aichat", label: "AI Chat", refKey: "linkAIChat" },
       { to: "/kbchatview", label: "Apprentice Assist", refKey: "linkApprenticeChat" },
    ],
  },
  {
    key: "admin",
    label: "Admin",
    icon: <FaCogs size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN"],
    links: [
      { to: "/addcompany", label: "Add company", refKey: "link4" },
      { to: "/managecompany", label: "Manage company", refKey: "link4b" },
    ],
  },
  {
    key: "company",
    label: "Company",
    icon: <FaCogs size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_CMANAGER", "OFFICE_MANAGER", "OPERATIONS_MANAGER"],
    links: [
      { to: "/company", label: "Company details", refKey: "linkCompany1" },
      { to: "/company/vehicle-rego", label: "Vehicle/Equipment Rego", refKey: "linkCompany2" },
    ],
  },
  {
    key: "employees",
    label: "Employee",
    icon: <FaUserFriends size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER"],
    links: [
      { to: "/invite", label: "Invite employee", refKey: "link5" },
      { to: "/employees", label: "Manage employee", refKey: "link5b" },
      { to: "/timesheetmanager", label: "Shift (hour) approvals", refKey: "link5c" },
      { to: "/leavemanager", label: "Leave approvals", refKey: "link5d" },
    ],
  },
  {
    key: "my-profile",
    label: "My Profile",
    icon: <FaUserFriends size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER", "ROLE_FMANAGER", "ROLE_EMPLOYEE", "ROLE_FWORKER"],
    links: [
      { to: "/my-profile", label: "Profile", refKey: "linkProfile1" },
      { to: "/my-profile/calendar", label: "Calendar", refKey: "linkProfile2" },
    ],
  },
  {
    key: "onboarding",
    label: "Onboarding",
    icon: <FaClipboardCheck size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER", "ROLE_FMANAGER", "ROLE_EMPLOYEE", "ROLE_FWORKER"],
    links: [
      {
        to: "/onboarding",
        label: "Onboarding hub",
        refKey: "linkOnboarding1",
        roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER", "ROLE_FMANAGER"],
      },
      { to: "/onboarding/me", label: "My onboarding", refKey: "linkOnboarding2" },
    ],
  },
  {
    key: "finance",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
        Finance
        <Tag color="purple" style={{ fontSize: 10, margin: 0 }}>
          BETA
        </Tag>
      </span>
    ),
    icon: <FaMoneyCheckAlt size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "FINANCE_MANAGER","OFFICE_MANAGER","OPERATIONS_MANAGER", "ROLE_CMANAGER", "ROLE_FMANAGER"],
    links: [
      { to: "/accounting/dashboard", label: "Dashboard", refKey: "linkAccountingDashboard" },
      { to: "/accounting/invoices", label: "Invoices", refKey: "linkAccountingInvoices" },
      { to: "/accounting/bills-expenses", label: "Bills/Expenses", refKey: "linkAccountingBills" },
      /*{ to: "/accounting/other-records", label: "Other Expenses", refKey: "linkAccountingOther" },*/
      /*{ to: "/accounting/bank-accounts", label: "Bank Accounts", refKey: "linkAccountingBank" },*/
      { to: "/accounting/bank-reconcile", label: "Bank Reconcile", refKey: "linkAccountingBankReconcile" },
      { to: "/accounting/bank-reconcile-basiq", label: "Bank Reconcile (Real time)", refKey: "linkAccountingBankReconcile" },

      { to: "/accounting/chart-of-accounts", label: "Chart of Accounts", refKey: "linkAccountingCOA" },
    ],
  },
  {
    key: "pays",
    label: (
      <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
        Pay
        <Tag color="purple" style={{ fontSize: 10, margin: 0 }}>
          BETA
        </Tag>
      </span>
    ),
    icon: <FaFileInvoiceDollar size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "FINANCE_MANAGER", "ROLE_CMANAGER"],
    links: [
      {
        to: "/payrunlist",
        label: "View payruns",
        refKey: "link7",
        roles: ["ROLE_SADMIN", "FINANCE_MANAGER", "ROLE_CMANAGER"],
      },
      {
        to: "/payruntrigger",
        label: "Trigger payrun",
        refKey: "link8",
        roles: ["ROLE_SADMIN", "FINANCE_MANAGER", "ROLE_CMANAGER"],
      },
    ],
  },
  {
    key: "reimbursements",
    label: "Reimbursement",
    icon: <FaCogs size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER", "ROLE_FMANAGER", "ROLE_EMPLOYEE", "ROLE_FWORKER"],
    links: [
      { to: "/reimburse", label: "Create +", refKey: "link1" },
      { to: "/myreimbursements", label: "Manage - mine", refKey: "link2" },
      {
        to: "/viewreimbursements",
        label: "Manage - others",
        refKey: "link3",
        roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER"],
      },
    ],
  },
  {
    key: "Service Admin",
    label: "Integrations",
    icon: <BsDice1 size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "FINANCE_MANAGER","OFFICE_MANAGER", "ROLE_CMANAGER"],
    links: [
      {
        to: "/xeroconfiguration",
        label: "Xero Configuration",
        refKey: "link12",
        roles: ["ROLE_SADMIN", "FINANCE_MANAGER","OFFICE_MANAGER", "ROLE_CMANAGER"],
      },
      {
        to: "/xeroconnet",
        label: "Xero Connect",
        refKey: "link11",
        roles: ["ROLE_SADMIN", "FINANCE_MANAGER","OFFICE_MANAGER", "ROLE_CMANAGER"],
      },
      {
        to: "/basiqconnect",
        label: "Basiq Connect",
        refKey: "link13",
        roles: ["ROLE_SADMIN", "FINANCE_MANAGER","OFFICE_MANAGER", "ROLE_CMANAGER"],
      },
       {
        to: "/stripeconnect",
        label: "Stripe Connect",
        refKey: "link14",
        roles: ["ROLE_SADMIN", "FINANCE_MANAGER","OFFICE_MANAGER", "ROLE_CMANAGER"],
      },
      {
        to: "/fiskilconnect",
        label: "Fiskil Connect",
        refKey: "link15",
        roles: ["ROLE_SADMIN", "FINANCE_MANAGER","OFFICE_MANAGER", "ROLE_CMANAGER"],
      },
    ],
  },
  {
    key: "search-jobs",
    label: "Explore Jobs",
    icon: <FaBriefcase size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER", "ROLE_FMANAGER", "ROLE_EMPLOYEE", "ROLE_FWORKER"],
    defaultRoute: "/jobs",
    links: [
      { to: "/jobs", label: "Explore Jobs", refKey: "linkSearchJobs" },
    ],
  },
  {
    key: "flexible-employment",
    label: "Employment board",
    icon: <FaBriefcase size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER"],
    defaultRoute: "/flexible-employment/jobs",
    links: [
      { to: "/flexible-employment/create-job", label: "Create Jobs", refKey: "linkFlexCreate" },
      { to: "/flexible-employment/jobs", label: "View Jobs", refKey: "linkFlexJobs" },
    ],
  },
  {
    key: "call-center",
    label: "CallCenter",
    icon: <FaPhoneAlt size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_MANAGER", "ROLE_CMANAGER", "ROLE_FMANAGER"],
    defaultRoute: "/callcenter",
    links: [
      { to: "/callcenter/numbers", label: "View list of available numbers", refKey: "linkCall1" },
      { to: "/callcenter/request", label: "Request a number", refKey: "linkCall2" },
      { to: "/callcenter/port", label: "Port number", refKey: "linkCall3" },
      { to: "/callcenter/change", label: "Change number", refKey: "linkCall4" },
    ],
  },
  {
    key: "kl",
    label: "Knowledge Library",
    icon: <FaBook size={20} style={{ position: "relative", bottom: -3, color: "white" }} />,
    roles: ["ROLE_SADMIN", "ROLE_CMANAGER"],
    links: [
      { to: "/inddocprocessing", label: "Document Processing", refKey: "link10" },
    ],
  },
];

export default function Navbar({ onOpenGuidedTour }) {
  const navigate = useNavigate();
  const userContext = useAuth();
  const location = useLocation();

  // Adjusted states: Start completely closed/collapsed by default on mobile devices
  const [isSmallDevice, setIsSmallDevice] = useState(window.innerWidth < 599);
  const [isNavOpen, setIsNavOpen] = useState(window.innerWidth >= 599);
  const [openSections, setOpenSections] = useState({});

  const {
    hasPermission,
    hasAnyPermission,

  } = usePermissions();

  const refs = {
    link1: useRef(null), link2: useRef(null), link3: useRef(null),
    link4: useRef(null), link5: useRef(null), link12: useRef(null),
    linkSearchJobs: useRef(null), linkFlexCreate: useRef(null),
    linkFlexJobs: useRef(null), linkProfile1: useRef(null), linkProfile2: useRef(null),
  };

  const changeStyleWhenLinkClicked = (...clickedKeys) => {
    for (const key in refs) {
      if (refs[key].current) {
        refs[key].current.style.fontWeight = clickedKeys.includes(key) ? "bold" : "";
      }
    }
  };

  const toggleSection = (sectionKey) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey],
    }));
  };

  const closeAllSections = () => {
    const closed = {};
    navSections.forEach((sec) => (closed[sec.key] = false));
    setOpenSections(closed);
  };

  const toggleNav = () => {
    setIsNavOpen((prev) => !prev);
    if (isSmallDevice) closeAllSections();
  };

  useEffect(() => {
    const handleResize = () => {
      const isSmall = window.innerWidth < 599;
      setIsSmallDevice(isSmall);
      if (isSmall) {
        setIsNavOpen(false); // Mobile defaults to hidden menu list flow
      } else {
        setIsNavOpen(true);  // Desktop remains open
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const matchedSection = navSections.find((section) =>
      section.links.some((link) => location.pathname.startsWith(link.to))
    );

    if (matchedSection && !isSmallDevice) {
      setOpenSections((prev) => ({
        ...prev,
        [matchedSection.key]: true,
      }));
    }
  }, [location.pathname, isSmallDevice]);

  return (
    <div className={`sidenav ${isSmallDevice ? "smalldevicewrapper" : ""} ${isNavOpen ? "nav-expanded" : "nav-collapsed"}`}>
      
      {/* Structural Mobile Top Banner Strip Wrapper */}
      <div className="mobile-header-bar">
        <div className="openSpan" onClick={toggleNav}>
          &#9776;
        </div>
        {isSmallDevice && <div className="mobile-title"></div>}
      </div>

      {/* Main Content Layout Block Container */}
      <div className="nav-items-wrapper">
        <div
          className="linkRoot"
          onClick={() => {
            if (onOpenGuidedTour) onOpenGuidedTour();
            if (isSmallDevice) setIsNavOpen(false);
          }}
        >
          <MdOutlineTour size={20} style={{ position: "relative", bottom: -3, color: "white" }} />
          <div className="linkSpan">Guided Tour</div>
        </div>

        {navSections.map((section) => {
          
          const hasSectionAccess =
            section.roles.length === 0 || (userContext && section.roles.includes(userContext.role))
            || hasAnyPermission(...section.roles);

          if (!hasSectionAccess) return null;

          return (
            <div key={section.key} className="nav-section-node">
              <div
                className="linkRoot"
                onClick={() => {
                  toggleSection(section.key);
                  if (section.defaultRoute) {
                    navigate(section.defaultRoute);
                    if (isSmallDevice && section.links.length === 1) setIsNavOpen(false);
                  }
                }}
              >
                {section.icon}
                <div className="linkSpan">{section.label}</div>
              </div>

              {openSections[section.key] && (
                <div className="subLinks">
                  {section.links.map((link) => {
                    const showLink =
                      !link.roles ||
                      link.roles.length === 0 ||
                      (userContext && link.roles.includes(userContext.role));

                    if (!showLink) return null;

                    return (
                      <Link
                        key={link.to}
                        ref={refs[link.refKey]}
                        to={link.to}
                        className={`subLink ${location.pathname === link.to ? "activeSubLink" : ""}`}
                        onClick={() => {
                          navigate(link.to);
                          changeStyleWhenLinkClicked(link.refKey);
                          if (isSmallDevice) setIsNavOpen(false); // Instantly hide dashboard layout on select
                        }}
                      >
                        <div className="linkSpan">{link.label}</div>
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}